import { get } from 'lodash';

export default function isClosed(fields) {
  const closed = get(fields, 'is_closed.value', '');
  return closed !== '' && closed;
}
